class IdleTimer {
    /**
     * initializes/clears the time tracker based on the current employee status
     * @param {timeout} total timeout
     * @param {onTimeout} action fired on timeout
     * @param {onTimeReach} action fired on reaching specific time
     */
    constructor({ timeout, onTimeout, onTimeReach }) {
      this.timeout = timeout;
      this.onTimeout = onTimeout;
      this.onTimeReach = onTimeReach;
      const startTime = parseInt(localStorage.getItem('_clockInOutStartTime') || 0, 10);
      // fire the onTimeout event if timeout initially
      if (startTime > 0 && (startTime + this.timeout * 1000) < Date.now()) {
        this.cleanUp();
        onTimeout();
        return;
      }
      this.eventHandler = this.updateStartTime.bind(this);
    }

    initTimer() {
        this.tracker();
        this.startInterval();
    }

    /**
     * add an interval which checks the timer and fires actions as required every second
     */
    startInterval() {
      this.updateStartTime(true);
      this.interval = setInterval(() => {
        const startTime = IdleTimer.getStartTime();
        const elapsed = (Date.now() - startTime) / 1000;
        console.log(elapsed);
        if (this.onTimeReach) {
          Object.keys(this.onTimeReach).forEach((t) => {
            if (t <= elapsed) {
              this.onTimeReach[t]?.({ elapsed });
            }
          });
        }
        if ((startTime + this.timeout * 1000) < Date.now()) {
          if (this.onTimeout) {
            this.onTimeout();
            this.cleanUp();
          }
        }
      }, 1000);
    }

    /**
     * reset the start time if any activity is recorded
     */
    updateStartTime(instantly = false) {
      if (instantly) {
        localStorage.setItem('_clockInOutStartTime', Date.now());
        return;
      }
        if (this.timeoutTracker) {
          clearTimeout(this.timeoutTracker);
        }
        this.timeoutTracker = setTimeout(() => {
          localStorage.setItem('_clockInOutStartTime', Date.now());
        }, 300);
    }

    /**
     * add windows event listner to track any activity
     */
    tracker() {
      window.addEventListener('mousemove', this.eventHandler);
      window.addEventListener('scroll', this.eventHandler);
      window.addEventListener('keydown', this.eventHandler);
    }

    /**
     * cleanUp the tracker
     */
    cleanUp() {
      clearInterval(this.interval);
      localStorage.removeItem('_clockInOutStartTime');
      this.clearTracker();
    }

    /**
     * clears windows event listner to track any activity
     */
    clearTracker() {
        window.removeEventListener('mousemove', this.eventHandler);
        window.removeEventListener('scroll', this.eventHandler);
        window.removeEventListener('keydown', this.eventHandler);
    }

    /**
     * clear the tracker(remove event listners and interval and reset them back)
     */
    reset() {
        this.clearTracker();
        clearInterval(this.interval);
        this.initTimer();
    }

    static getStartTime() {
      return parseInt(
        localStorage.getItem('_clockInOutStartTime') || 0,
        10
      );
    }
}
export default IdleTimer;
